import { render, staticRenderFns } from "./GuestsRating.vue?vue&type=template&id=23e10c5b"
import script from "./GuestsRating.vue?vue&type=script&lang=js"
export * from "./GuestsRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports